import { z } from 'zod'

export const CCOutstandingExpenseComingSoonStateSchema = z.object({
  stage: z.literal('coming-soon-modal'),
})

export const CCOutstandingExpenseComingSoonLocationStateSchema = z.object({
  CCOutstandingExpenseComingSoonModal:
    CCOutstandingExpenseComingSoonStateSchema,
})

export type CCOutstandingExpenseComingSoonState = z.TypeOf<
  typeof CCOutstandingExpenseComingSoonStateSchema
>
